import { useContext } from 'react';
import { ThemeContext } from '@lib/context/ThemeContextWrapper';
import { ThemeContextType } from '@lib/context/ThemeContext';

const HBS_THEME_NAMES = ['axa', 'hbs', 'hbsgast'];

export const useTheme = (): ThemeContextType & {isHBSTheme: boolean} => {
  const context: ThemeContextType = useContext(ThemeContext);
  const isHBSTheme: boolean = HBS_THEME_NAMES.includes(context?.theme?.id || '');

  return {
    ...context,
    isHBSTheme,
  };
}

export default useTheme;
